import { MinusIcon, CheckmarkIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';

function CheckIcon({ ...rest }) {
  return /* @__PURE__ */ React.createElement(CheckmarkIcon, { size: "xSmall", withBoundingBox: true, className: clsx(rest.className, "kohler-check-icon") });
}
function CheckboxIcon({ indeterminate, ...rest }) {
  if (indeterminate) {
    return /* @__PURE__ */ React.createElement(MinusIcon, { size: "xSmall", withBoundingBox: true, className: clsx(rest.className, "kohler-check-icon") });
  }
  return /* @__PURE__ */ React.createElement(CheckIcon, { ...rest });
}

export { CheckIcon, CheckboxIcon };
